import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecStepLabelTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            iconContainer: {
                padding: 0,
            },
            labelContainer: {
                position: "absolute",
                width: "auto",
                transform: "translateY(150%)",
            },
            label: {
                fontFamily: "Mark Pro, sans-serif",
                fontWeight: "500",
                fontSize: "16px !important",
                whiteSpace: "nowrap",
                "&.Mui-active": {
                    color: theme.palette.deepBlue.main,
                },
                "&.Mui-completed": {
                    color: theme.palette.deepBlue.main,
                },
                "&.Mui-disabled": {
                    color: theme.palette.neutralGray40.main,
                },
            },
            root: {
                flexDirection: "column",
                position: "relative",
            },
        },
    };
};
